import http from "./httpService";

const apiEndpoint ="/api/files";

export function add(data) {
  http.setAccessCOntrolOrigin();
  return http.post(apiEndpoint, data);
}

// function get(_id){
//     // return http.get(apiEndpoint+"/"+_id);
// }

export function getAll() {
  return http.get(apiEndpoint);
}

export function remove(_id) {
  return http.delete(apiEndpoint + "/" + _id);
}

export function upload(file) {
  http
    .get(apiEndpoint + "/" + file._id, { responseType: "blob" })
    .then((response) => {
      if (response.status === 200) {
        let url = window.URL.createObjectURL(new Blob([response.data]));
        let a = document.createElement("a");
        a.href = url;
        a.download = file.name + ".mp3";
        a.click();
      }
    });
}
